import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginComponent } from './login/login.component';
import {LoginService} from "./login.service";
import {HttpClientService} from "./http-client.service";
import {AuthenticationService} from "./authentication-service.service";
import {GlobalDataService} from "./global-data.service";
import {AppConfigService} from "./app-config.service";
import { GridModule } from '@progress/kendo-angular-grid';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { ViewOrdersComponent } from './view-orders/view-orders.component';
import { ManageOrderComponent } from './manage-order/manage-order.component';
import { ManagePartnerComponent } from './manage-partner/manage-partner.component';
import { ManageCustomerComponent } from './manage-customer/manage-customer.component';
import { ManageContactComponent } from './manage-contact/manage-contact.component';
import { CreateCustomerComponent } from './create-customer/create-customer.component';
import { CreateSubscriptionComponent } from './create-subscription/create-subscription.component';
import { CreatePartnerComponent } from './create-partner/create-partner.component';
import { ViewCustomersComponent } from './view-customers/view-customers.component';
import { ViewPartnersComponent } from './view-partners/view-partners.component';
import { ViewSubscriptionsComponent } from './view-subscriptions/view-subscriptions.component';
import { ManageSubscriptionComponent } from './manage-subscription/manage-subscription.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { ViewUsersComponent } from './view-users/view-users.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SkySwitchLoginComponent } from './skyswitch-login/skyswitch-login.component';
import { SkyswitchSsoComponent } from './skyswitch-sso/skyswitch-sso.component';

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    CreateOrderComponent,
    ViewOrdersComponent,
    ManageOrderComponent,
    ManagePartnerComponent,
    ManageCustomerComponent,
    ManageContactComponent,
    CreateCustomerComponent,
    CreateSubscriptionComponent,
    CreatePartnerComponent,
    ViewCustomersComponent,
    ViewPartnersComponent,
    ViewSubscriptionsComponent,
    ManageSubscriptionComponent,
    CreateUserComponent,
    ManageUserComponent,
    ViewUsersComponent,
    ChangePasswordComponent,
    SkySwitchLoginComponent,
    SkyswitchSsoComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpModule,
    GridModule
  ],
  providers: [GlobalDataService,
    AuthenticationService,
    HttpClientService,
    LoginService,
    CookieService,
    AppConfigService,
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService], multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts